import { drParam } from "./drParam";
import { DateTime } from 'luxon';

export class drConfig {
    ID: number;
    ConfigID: number;
    ConfigGUID: string;
    Code: string;
    Value: string;
    Note: string;
    Ordering: number;

    // Nuovi campi
    StoreID: number;
    ParentID: number;
    ContactID: number;
    PropertyType: string;

    C: boolean[];
    D: DateTime[] | null[];
    T: string[];
    N: number[];
    M: string[];
    
    Created = null;
    CreatedBy: string;
    Modified = null;
    ModifiedBy: string;
    // LastChange: number;
    
    // variabili di supporto
    fields: drParam[];
    hasSubItems: boolean;

    constructor(id: number = 0, code: string = '') {
        this.ID = id;
        this.ConfigID = 0;
        this.ConfigGUID = '';
        this.Code = code;
        this.Value = '';
        this.Note = '';
        this.Ordering = 0;
        
        this.Created = null;
        this.CreatedBy = '';
        this.Modified = null;
        this.ModifiedBy = '';
        // this.LastChange = 0;
        

        // Nuovi campi
        this.StoreID = 0;
        this.ParentID = 0;
        this.ContactID = 0;
        this.PropertyType = '';

        this.C = [false, false, false, false, false, false, false, false];
        this.D = [null, null, null, null, null, null, null, null];
        this.T = ['', '', '', '', '', '', '', ''];
        this.M = ['', '', '', '', '', '', '', ''];
        this.N = [0, 0, 0, 0, 0, 0, 0, 0];

        this.fields = [];
        this.hasSubItems = false;
    }
}

export class GetConfigReq {
    myToken: string;
    id: number;
    guid: string;
    code: string;
    note: string;

    constructor() {
        this.myToken = '';
        this.id = 0;
        this.guid = '';
        this.code = '';
        this.note = '';
    }
}

export class GetConfigResp {
    error: string = '';
    config: drConfig | null = null;
}

export class SetConfigReq {
    myToken: string = '';
    config: drConfig | null = null;
}

export class SetConfigResp {
    error: string = '';
    config: drConfig | null = null;
}

export class GetConfigListReq {
    myToken: string = '';
    store: string = '';
    note: string = '';
    contactId: number = 0;
    orderBy: string = '';
    searchText: string = '';
    filterBy: string = '';  // sezione delle traduzioni
    pageNum: number = 0;
    pageSize: number = 100;
    parentId: number = 0;

}
export class GetConfigListResp {
    error: string = '';
    configs: drConfig[] = [];
    numPages: number = 0;
    numTutti: number = 0;
}
